var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Share Icon - Green"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32905",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 837",
    d: "M67 68.75H7A1.75 1.75 0 015.25 67V7A1.75 1.75 0 017 5.25h36.846A1.75 1.75 0 0145.596 7a1.75 1.75 0 01-1.75 1.75h-35.1v56.5h56.5V28.77a1.75 1.75 0 011.75-1.75 1.75 1.75 0 011.75 1.75V67A1.75 1.75 0 0167 68.75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 838",
    d: "M67.071 21.814a1.75 1.75 0 01-1.75-1.74L65.26 8.75H52.578A1.75 1.75 0 0150.828 7a1.75 1.75 0 011.75-1.75H67a1.75 1.75 0 011.75 1.74l.07 13.064a1.75 1.75 0 01-1.74 1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 998",
    d: "M41.168 34.584a1.745 1.745 0 01-1.237-.513 1.75 1.75 0 010-2.475l25-25a1.75 1.75 0 012.475 0 1.75 1.75 0 010 2.475l-25 25a1.745 1.745 0 01-1.238.513z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32904"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 25865",
    fill: "none",
    d: "M0 0h74v74H0z"
  })))));
}

export default __webpack_public_path__ + "f155e6cc521d7b6cd5d1c3c61e80f917.svg";
export { SvgShareIcon as ReactComponent };